import { isStoredObject, parseStoredJson } from "@/utils/storedValue";
import type { Timeframe } from "./AuditLogFilterSidebar";

// The audit log's Since/Until bounds in per-user storage: ISO strings on
// the way in, Dates on the way out, and the unfiltered default stored as
// absence like the page's other filters.

function parseIsoDate(value: unknown): Date | undefined {
  if (typeof value !== "string") return undefined;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? undefined : date;
}

export function parseTimeframe(raw: string | null): Timeframe {
  const parsed = parseStoredJson(raw);
  if (!isStoredObject(parsed)) return {};
  const timeframe: Timeframe = {};
  const since = parseIsoDate(parsed.since);
  const until = parseIsoDate(parsed.until);
  if (since) timeframe.since = since;
  if (until) timeframe.until = until;
  return timeframe;
}

export function serializeTimeframe(timeframe: Timeframe): string | null {
  if (!timeframe.since && !timeframe.until) return null;
  return JSON.stringify({
    since: timeframe.since?.toISOString(),
    until: timeframe.until?.toISOString(),
  });
}
